/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {readUserSettings} from '../api'

 export const useQueryReadUserSettings = createReactQueryHook('readUserSettings', readUserSettings)
